import React from "react";

import { TRIGGER_TYPE_OPTIONS } from "api/model/alerts/alert-types";
import { Button } from "primereact/button";
import { Tag } from "primereact/tag";
import { T } from "services/lang/LanguageService";
import { TriggerData, TriggerFormItem } from "./types";
import { formatTriggerSettings } from "./utils";

type TriggerCardProps = {
  item: TriggerFormItem;
  onEdit?: () => void;
  onRemove: () => void;
};

const TriggerCard: React.FC<TriggerCardProps> = ({ item, onEdit, onRemove }) => {
  const displayData: TriggerData | undefined =
    item.isEdited && item.editedData ? item.editedData : item.existingTrigger || item.newTrigger;

  if (!displayData) return null;

  return (
    <div className="border-1 border-200 border-round p-3 mb-2 surface-50">
      <div className="flex justify-content-between align-items-start">
        <div className="flex-grow-1">
          <div className="flex align-items-center gap-2 mb-2">
            <span className="font-semibold text-lg">{displayData.name}</span>
            <Tag
              value={TRIGGER_TYPE_OPTIONS.find(o => o.value === displayData.triggerType)?.label}
              severity={item.isExisting ? "success" : "info"}
            />
            {item.isEdited && <Tag value={T("word.edited")} severity="warning" />}
          </div>
          <div className="text-sm text-600">
            <div>
              {T("word.retention-time")}: {displayData.retentionTime}s
            </div>
            <div className="mt-1">{formatTriggerSettings(displayData.triggerType, displayData.settings)}</div>
          </div>
        </div>
        <div className="flex gap-2">
          {item.isExisting && onEdit && (
            <Button
              type="button"
              icon="pi pi-pencil"
              onClick={onEdit}
              className="p-button-sm p-button-text"
              tooltip={T("action.edit")}
            />
          )}
          <Button
            type="button"
            icon="pi pi-trash"
            onClick={onRemove}
            className="p-button-sm p-button-danger p-button-text"
            tooltip={T("action.remove")}
          />
        </div>
      </div>
    </div>
  );
};

export default TriggerCard;
